import React from 'react';

const NOT_AVAILABLE = '--';

type ExploitabilityFieldProps = {
  fieldName: string,
  fieldValue: string | undefined
}

export const ExploitabilityField: React.FC = ({fieldName, fieldValue}: ExploitabilityFieldProps) => {
  return (
    <div className="grid__item col-1-1">
      <div className="grid pt-">
        <div className="grid__item col-1-3 phone--col-1-1">{`${fieldName}:`}</div>
        <div className="grid__item col-2-3 phone--col-1-1 max-width--500">{fieldValue ?? NOT_AVAILABLE}</div>
      </div>
    </div>
  );
};

export default ExploitabilityField;
